import { enumCellContentType, enumFillMode, kPickerColorCodes, kPickerColors } from "../constants";

export function SetupTableCell(
  theLayout,
  x,
  y,
  textVal,
  cellFill,
  textBold,
  wrapText,
  fontSize,
  extend
) {
  var c1 = theLayout.GetCellDesc(x, y);
  c1.SetAlignment("left");
  c1.SetCellContentType(enumCellContentType.FreeText);
  if (cellFill != null) {
    var ci = kPickerColorCodes.indexOf(cellFill);
    var fillColor = kPickerColors[ci];

    c1.SetCellFillMode(enumFillMode.solidFill);
    c1.SetCellFillColor(fillColor);
  }
  c1.SetTextBold(textBold);
  c1.SetFreeText(textVal);
  if (fontSize) c1.SetFontSize(fontSize);
  if (wrapText != null) c1.SetWrapText(wrapText);

  if (extend) {
    var numCols = theLayout.GetNumCols();
    for (var i = x; i <= numCols; i++) {
      var c2 = theLayout.GetCellDesc(i + 1, y);
      if (c2 && fillColor && !c2.IsGutterCell()) {
        c2.SetCellFillMode(enumFillMode.solidFill);
        c2.SetCellFillColor(fillColor);
      }
    }
  }
  return c1;
}
